export const HomePage = () => (<h1 className="title">Home Page</h1>);
